module.exports = __webpack_public_path__ + "img/sgb_logo_new.9e57d3f0.png";